/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![AtIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACzElEQVR4nM1VXYhNURQ+g5CfCUl58ELxwCOFcB+4uXXPXmvtqXPWunMnV6KkkEl5QCMh5cETD+KFaIoXpJQpYspf/mriZWKERiEvwyB/7XP2OXe75864E8qq8/Lttdda31rfWdvz/gcrFlunIoarQcsWhbzDx9ImxJIi4jl/FNin0jJAuaiQvwDJj3qfIn6AyK2e5zU1HDgIgklAcrIm2Acg7lHElxTJdSB5XnPe5ful6Y0En6aI77sVKuS1uUplfK0vgCwE5FNpEpSHhUK5ebjgowH5mr3wXSHvMdjvigIdikL5au8dH9JRoWyuUuad7lmxpXU2gGiAcEUQBGMN5vv+hISZ8Y8YI38DCOZlghtHQOm3VLuToRUK5WYgPmcYOf1+qbTkFcpnQH4S+xXGAfGbOInsy1ZP3JIGgHBVtWXSnc4D5TGg3LHJPtlibqatQjkaY3yjTnv4WFJdUj2QrHOq3pgGIm6vDpbPOPhW26YX9RjcilUjp6uYXLHYVdfXzMD5N/YnuPkfLKv+TAJA7rMX9joVvbYDb8/42zPE0voEM3+49X+UTZAGk11VTOI+Q7gmyyCWpY+80mnzCcu4s16CHpv9cJYV/yJZ0BwkMzDyTdSmiN9HuA7LdRJIl/1zz6YVEV+2gZ5qXZ4ZYUrmu2uCiOdGjEg6rdJ6jWTrJThkHd7lcrkxEQYCjkQ/msuxRHnAJLXteKaIX1mmA4i8PBM8qkyHi539g9XB8XZAHnRk2Wf6bnxcXCHf9qm0xBvGmtyq8vm2ickBYmWKWd1FHS7o6OgYleBat81A5KWIPMtrxBCZ3fVrHhrvbxsQH3H63qtIKi4b18zAFfJuo3vDrtEcTYB8INqKlPZ9UBHfVcQXzAtn9pNCflvz4BwcERNfh4sU8floYw7xXEaKQrkHINsAYPKIEiRmBmxWs1kD5sE3H5BsMEpq6In81/YTx/rLwz52RMYAAAAASUVORK5CYII=)
 */
export const AtIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16.44 6.96c.29 0 .51.25.47.54l-.82 6.34c-.02.08-.03.2-.03.34 0 .71.28 1.07.85 1.07.49 0 .94-.21 1.36-.63.43-.42.77-1 1.02-1.72.26-.75.38-1.57.38-2.48 0-1.35-.29-2.54-.87-3.56a5.92 5.92 0 0 0-2.45-2.35 7.68 7.68 0 0 0-3.61-.83c-1.55 0-2.96.37-4.22 1.1a7.66 7.66 0 0 0-2.96 3.07 9.53 9.53 0 0 0-1.09 4.66c0 1.45.26 2.77.78 3.95a6.3 6.3 0 0 0 2.47 2.81 8.3 8.3 0 0 0 4.36 1.05 12.43 12.43 0 0 0 5.35-1.18.5.5 0 0 1 .7.24l.46 1.07c.1.22.02.47-.19.59-.77.43-1.69.77-2.75 1.02-1.23.3-2.48.44-3.76.44-2.18 0-4-.44-5.48-1.33a8.1 8.1 0 0 1-3.27-3.57 11.93 11.93 0 0 1-1.07-5.12c0-2.24.47-4.19 1.4-5.84a9.7 9.7 0 0 1 3.86-3.8c1.62-.9 3.4-1.34 5.36-1.34 1.8 0 3.4.37 4.8 1.12 1.4.72 2.5 1.76 3.28 3.1a8.86 8.86 0 0 1 1.16 4.56c0 1.36-.23 2.57-.7 3.64a5.81 5.81 0 0 1-1.92 2.47c-.82.58-1.76.87-2.81.87a2.4 2.4 0 0 1-1.6-.5c-.4-.35-.65-.78-.73-1.32-.3.55-.74 1-1.36 1.34a4.3 4.3 0 0 1-2.03.48A3.4 3.4 0 0 1 8 16C7.33 15.16 7 14 7 12.5c0-1.14.2-2.16.6-3.05.43-.89 1-1.57 1.73-2.06a4.3 4.3 0 0 1 4.27-.31c.47.29.82.68 1.07 1.16l.3-.95c.06-.2.25-.33.46-.33h1.02Zm-5.06 8.24c.8 0 1.45-.35 1.97-1.04.51-.7.77-1.6.77-2.7 0-.88-.18-1.56-.53-2.03a1.76 1.76 0 0 0-1.5-.73c-.8 0-1.45.35-1.97 1.04a4.28 4.28 0 0 0-.78 2.67c0 .9.17 1.58.51 2.06.36.49.87.73 1.53.73Z"
        className={colorClass}
      />
    </svg>
  );
};
